import { Button, Checkbox, FormControlLabel, FormGroup, styled } from "@mui/material";
import { get, isEmpty } from "lodash";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import "./TotalConsiderationForm.css";

const StyledFormGroup = styled(FormGroup)({
    display: "inline-block",
});

const TotalConsiderationForm = (props) => {
    const {
        deal,
        disableInputs,
        errors,
        handleAutocalculateTiSf,
        handleBlurValidate,
        handleCalculateTotalConsiderationDetails,
        handleClearRentSchedule,
        handleTotalConsiderationAmountChange,
        handleTotalConsiderationChange,
        invoice,
        totalConsideration,
        transactionType,
    } = props;

    const isComplete = deal?.isPartiallyComplete === false;

    const handleChangeEvent = (event) => {
        handleTotalConsiderationChange(event.target.id, event.target.value);
    };

    const handleCheckboxEvent = (event, checked) => {
        handleTotalConsiderationChange(event.target.value, checked);
    };

    const handleAnnualCheckboxEvent = (event, checked) => {
        handleTotalConsiderationChange(event.target.value, checked);
        if (checked) {
            handleTotalConsiderationChange("ratePerMonth", null);
            handleTotalConsiderationChange("ratePerSqftPerMonth", null);
            handleTotalConsiderationChange("ratePerSqftPerYear", null);
        } else {
            handleTotalConsiderationChange("ratePerYear", null);
        }
    };

    if (totalConsideration.escalationRateType == null) {
        handleTotalConsiderationChange("escalationRateType", "%");
    }

    return (
        <form>
            {transactionType !== "SALE" && (
                <div>
                    <div className="totalConsiderationFlexContainer">
                        <small className="totalConsiderateNote">
                            Please input the fields marked as required below. Generating your rent schedule is not
                            required. If you do generate your rent schedule, this information can be auto-populated on a
                            KM Invoice by clicking the "Generate Invoice" button at the top of this form. The generated
                            invoice will be in a word document, so you can make changes as needed.
                        </small>
                    </div>
                    <div className="totalConsiderationFlexContainer">
                        <div className="totalConsiderationFlexContainerUnresponsive">
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="totalConsiderationAmount"
                                    helperText="Required"
                                    errorText="Required"
                                    label="TOTAL CONSID. (OFFICIAL)*"
                                    toolTipText="This is the official Total Consideration for the transaction.
                                            This is a free form field, so it is not dependent on the optional calendar below.
                                            If you would like, you can input this field with the additional required fields and
                                            move forward without calculating the rent roll."
                                    value={get(deal, "totalConsiderationAmount", null)}
                                    error={errors.totalConsiderationAmount}
                                    onChange={(e) => handleTotalConsiderationAmountChange(e.target.value)}
                                    placeholder="Total Consideration Amount"
                                    disabled={disableInputs === true}
                                    startAdornment="$"
                                    onBlurValidate={(id, value) => handleBlurValidate(transactionType, id, value)}
                                    numeric
                                />
                            </div>
                        </div>
                        <div className="totalConsiderationFlexContainerUnresponsive">
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="commencementDate"
                                    label="Commencement Date*"
                                    helperText="Required"
                                    errorText="Required"
                                    value={totalConsideration.commencementDate}
                                    error={errors.commencementDate}
                                    onChange={handleChangeEvent}
                                    placeholder="Commencement Date"
                                    disabled={disableInputs === true}
                                    type="date"
                                    onBlurValidate={(id, value) => handleBlurValidate("totalConsideration", id, value)}
                                />
                            </div>
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="expirationDate"
                                    label="Expiration Date*"
                                    helperText="Required"
                                    errorText="Required"
                                    value={totalConsideration.expirationDate}
                                    error={errors.expirationDate}
                                    onChange={handleChangeEvent}
                                    placeholder="Expiration Date"
                                    disabled={disableInputs === true}
                                    type="date"
                                    onBlurValidate={(id, value) => handleBlurValidate("totalConsideration", id, value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="totalConsiderationFlexContainer">
                        <div className="totalConsiderationFlexContainerUnresponsive">
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="termNumMonths"
                                    label="Term (Months)*"
                                    helperText="Required"
                                    errorText="Required (ex. 9)"
                                    error={errors.termNumMonths}
                                    value={totalConsideration.termNumMonths}
                                    onChange={handleChangeEvent}
                                    disabled={disableInputs === true}
                                    onBlurValidate={(id, value) => handleBlurValidate("totalConsideration", id, value)}
                                />
                            </div>
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="squareFeet"
                                    label="Square Feet*"
                                    helperText="Required"
                                    errorText="Required (ex. 98101)"
                                    error={errors.squareFeet}
                                    value={totalConsideration.squareFeet}
                                    onChange={handleAutocalculateTiSf}
                                    placeholder="Enter square feet"
                                    disabled={disableInputs === true}
                                    integer
                                    onBlurValidate={(id, value) => handleBlurValidate("totalConsideration", id, value)}
                                />
                            </div>
                        </div>
                        <div className="totalConsiderationFlexContainerUnresponsive">
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="preTermFreeMonths"
                                    error={errors.preTermFreeMonths}
                                    value={totalConsideration.preTermFreeMonths}
                                    label="STARTING FREE MONTHS (OUTSIDE TERM)"
                                    toolTipText="If your lease has starting free months outside of the term, please input them here.
                                                        If your lease only has free months inside the term, please disregard this field and
                                                        input your free months by expanding the term that is generated by the calculator below."
                                    onChange={handleChangeEvent}
                                    disabled={disableInputs === true}
                                    placeholder="Number free months before term"
                                    integer
                                />
                            </div>
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="postTermFreeMonths"
                                    error={errors.postTermFreeMonths}
                                    value={totalConsideration.postTermFreeMonths}
                                    label="ENDING FREE MONTHS (OUTSIDE TERM)"
                                    toolTipText="If your lease has ending free months outside of the term, please input them here.
                                                        If your lease only has free months inside the term, please disregard this field and
                                                        input your free months by expanding the term that is generated by the calculator below."
                                    onChange={handleChangeEvent}
                                    placeholder="Number free months after term"
                                    disabled={disableInputs === true}
                                    integer
                                />
                            </div>
                        </div>
                    </div>

                    <div className="totalConsiderationFlexContainer">
                        <div className="totalConsiderationFlexContainerUnresponsive">
                            <div style={{ flex: "0 0 27%", alignSelf: "flex-start", paddingTop: "22px" }}>
                                <StyledFormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color={"primary"}
                                                checked={totalConsideration.annualRentForCalcFlg}
                                                onChange={(e, c) => handleAnnualCheckboxEvent(e, c)}
                                                value="annualRentForCalcFlg"
                                                disabled={disableInputs === true}
                                            />
                                        }
                                        label="Use Annual Rent for Calculations"
                                    />
                                </StyledFormGroup>
                            </div>
                            {totalConsideration.annualRentForCalcFlg ? (
                                <div className="totalConsiderationFlexContainerUnresponsive">
                                    <BSInput
                                        id="ratePerYear"
                                        label="Rent/Year*"
                                        helperText="Required"
                                        errorText="Required (ex. 981.01)"
                                        error={errors.ratePerYear}
                                        value={totalConsideration.ratePerYear}
                                        onChange={handleChangeEvent}
                                        startAdornment="$"
                                        disabled={disableInputs === true}
                                        numeric
                                        onBlurValidate={(id, value) =>
                                            handleBlurValidate("annualRentCalculationConstraints", id, value)
                                        }
                                    />
                                </div>
                            ) : (
                                <div className="totalConsiderationFlexContainerUnresponsive">
                                    <div className="flexGrowSingle">
                                        <BSInput
                                            id="ratePerSqftPerMonth"
                                            label="Rent/SF/Month*"
                                            helperText="Required"
                                            errorText="Required (ex. 9.01)"
                                            error={errors.ratePerSqftPerMonth}
                                            value={totalConsideration.ratePerSqftPerMonth}
                                            onChange={handleChangeEvent}
                                            startAdornment="$"
                                            disabled={disableInputs === true}
                                            numeric
                                            onBlurValidate={(id, value) =>
                                                handleBlurValidate("montlyRentCalculationConstraints", id, value)
                                            }
                                        />
                                    </div>
                                    <div className="flexGrowSingle">
                                        <BSInput
                                            id="ratePerSqftPerYear"
                                            label="Rent/SF/Year*"
                                            helperText="Required"
                                            errorText="Required (ex. 9.01)"
                                            error={errors.ratePerSqftPerYear}
                                            value={totalConsideration.ratePerSqftPerYear}
                                            onChange={handleChangeEvent}
                                            startAdornment="$"
                                            disabled={disableInputs === true}
                                            numeric
                                            onBlurValidate={(id, value) =>
                                                handleBlurValidate("montlyRentCalculationConstraints", id, value)
                                            }
                                        />
                                    </div>
                                    <div className="flexGrowSingle">
                                        <BSInput
                                            id="ratePerMonth"
                                            label="Rent/Month*"
                                            helperText="Required"
                                            errorText="Required (ex. 9.01)"
                                            error={errors.ratePerMonth}
                                            value={totalConsideration.ratePerMonth}
                                            onChange={handleChangeEvent}
                                            startAdornment="$"
                                            disabled={disableInputs === true}
                                            numeric
                                            onBlurValidate={(id, value) =>
                                                handleBlurValidate("montlyRentCalculationConstraints", id, value)
                                            }
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="totalConsiderationFlexContainerUnresponsive">
                            <div className="totalConsiderationEscalationContainer">
                                <BSInput
                                    id="escalationRate"
                                    label={isComplete ? "Escalation Rate*" : "Escalation Rate"}
                                    helperText={isComplete ? "Required" : ""}
                                    errorText="Required (ex. 981.01)"
                                    value={totalConsideration.escalationRate}
                                    error={isComplete ? errors.escalationRate : false}
                                    onChange={handleChangeEvent}
                                    placeholder="Enter escalation rate"
                                    disabled={disableInputs === true}
                                    extraInputStyles={{ borderRadius: "4px 0px 0px 4px" }}
                                    extraFormStyles={{ flex: "1 1 0" }}
                                    onBlurValidate={(id, value) => handleBlurValidate("totalConsideration", id, value)}
                                />
                                <div style={{ width: "fit-content" }}>
                                    <BSSelect
                                        id="escalationRateType"
                                        fullWidth
                                        combinedField="shiftLeft"
                                        error={isComplete ? errors.escalationRate : false}
                                        hideErrorIcon
                                        value={totalConsideration.escalationRateType}
                                        onChange={handleChangeEvent}
                                        disabled={disableInputs === true}
                                        extraInputStyles={{ paddingRight: 15 }}
                                        options={[
                                            {
                                                value: "%",
                                                label: "%",
                                            },
                                            {
                                                value: "$",
                                                label: "$",
                                            },
                                        ]}
                                    />
                                </div>
                            </div>
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="escalationTerm"
                                    label={
                                        isComplete ? "Escalation Frequency (Months)*" : "Escalation Frequency (Months)"
                                    }
                                    helperText={isComplete ? "Required" : ""}
                                    errorText="Required"
                                    value={totalConsideration.escalationTerm}
                                    error={isComplete ? errors.escalationTerm : false}
                                    placeholder="Enter months"
                                    disabled={disableInputs === true}
                                    onChange={handleChangeEvent}
                                    onBlurValidate={(id, value) => handleBlurValidate("totalConsideration", id, value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <StyledFormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color={"primary"}
                                        checked={totalConsideration.escalateAtYearStart ? true : false}
                                        onChange={(e, c) => handleCheckboxEvent(e, c)}
                                        value="escalateAtYearStart"
                                        disabled={disableInputs === true}
                                    />
                                }
                                label="Escalate at 1st of the year?"
                            />
                        </StyledFormGroup>
                    </div>

                    <div>
                        {disableInputs !== true &&
                            (!invoice ||
                                (invoice && !invoice["periods"]) ||
                                (invoice && invoice["periods"] && isEmpty(invoice["periods"]))) && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleCalculateTotalConsiderationDetails}
                                    style={{ marginLeft: "0" }}
                                >
                                    Generate Rent Schedule (Optional)
                                </Button>
                            )}

                        {disableInputs !== true && invoice && invoice["periods"] && !isEmpty(invoice["periods"]) && (
                            <Button variant="contained" color="primary" onClick={handleClearRentSchedule}>
                                Clear Rent Schedule
                            </Button>
                        )}
                    </div>
                </div>
            )}
        </form>
    );
};

export default TotalConsiderationForm;
